module.exports = __webpack_public_path__ + "img/xroad7_large.3ac5a7c4.svg";